import { render, staticRenderFns } from "./ClubServiceCard.vue?vue&type=template&id=262c49d2&scoped=true&"
import script from "./ClubServiceCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClubServiceCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ClubServiceCard.vue?vue&type=style&index=0&id=262c49d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262c49d2",
  null
  
)

export default component.exports